export default __webpack_public_path__ + "static/media/SOLID_AR_AI.c8ee4837.png";